import {
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import { isHorizontallyStretched } from '@wix/editor-elements-common-utils';
import type {
  CustomElementComponentDefinition,
  ICustomElementComponentMapperProps,
  CustomElementComponentCSSVars,
} from '../types';

export const props = withCompInfo<
  ICustomElementComponentMapperProps,
  CustomElementComponentDefinition
>()(
  ['compData'],
  ({ compData: { initialAttributes, shouldReload, appDefinitionId } }) => {
    return { initialAttributes, shouldReload, appDefinitionId };
  },
);

export const css = withCompInfo<
  Partial<CustomElementComponentCSSVars>,
  CustomElementComponentDefinition
>()(
  ['compLayout', 'hasResponsiveLayout'],
  ({ compLayout, hasResponsiveLayout }) => {
    const getCustomElementWidth = () => {
      if (hasResponsiveLayout || isHorizontallyStretched(compLayout)) {
        return '100%';
      }

      return `${compLayout.width}px`;
    };

    const getCustomElementHeight = () => {
      if (hasResponsiveLayout) {
        return '100%';
      }

      return `${compLayout.height}px`;
    };

    return {
      ...(!hasResponsiveLayout && {
        width: 'auto',
        height: 'auto',
      }),
      '--custom-element-width': getCustomElementWidth(),
      '--custom-element-height': getCustomElementHeight(),
      display: 'var(--display)',
      '--display': 'flex',
    };
  },
);

const uiType = withCompInfo<any, CustomElementComponentDefinition>()(
  ['skin'],
  ({ skin }) => (skin === 'CustomElement' ? 'CustomElement' : 'Default'),
);

export default createComponentMapperModel({ props, css, uiType });
